const appConfig = {
  siteConfig: {
    paidCurrency: 'ILS',
    travelRateMargin: '0.2',
    defaultLang: 'he_IL',
    languages: [
      'he',
      'en',
      {
        dir: 'rtl',
        code: 'he_IL',
        name: 'עברית',
      },
      {
        dir: 'ltr',
        code: 'en_US',
        name: 'English',
      },
      {
        dir: 'ltr',
        code: 'uk_UA',
        name: 'українська',
      },
      {
        dir: 'rtl',
        code: 'he_IL',
        name: 'עברית',
      },
      {
        dir: 'ltr',
        code: 'en_US',
        name: 'English',
      },
      {
        dir: 'ltr',
        code: 'uk_UA',
        name: 'українська',
      },
    ],
    logo: 'uploads/8/Website/dummy_174825509568344177ac7261.37796772.png',
    name: 'Tazo Playground',
    email: {
      title: 'זמינים במייל',
      value: 'opr@sky360.co.il',
    },
    phone: {
      hours: 'שעות פעילות 09:00-17:00',
      title: 'התקשרו או כתבו לנו בוואטסאפ',
      value: '077-998-4698',
    },
    style: {
      topClass: 'b2c-sky360',
    },
    domain: 'localhost',
    favIcon: 'uploads/8/Website/dummy_174825512568344195a09fd9.05012635.png',
    facebook: {
      title: 'פרגנו לנו בעוקב בפייסבוק',
      value: 'https://www.facebook.com/familybreak.co.il/',
    },
    whatsapp: {
      phone: '077-998-4698',
      countryCode: '972',
      introMessage: 'ברוכים הבאים למענה של סקיי 360!',
    },
    direction: 'rtl',
    hotelStar: ['3', '4', '5', '3', '4', '5'],
    instagram: {
      title: 'פרגנו לנו בעוקב באינסטגרם',
      value: 'https://www.instagram.com/familybreak.co.il/',
    },
    is_active: 0,
    logoSmall: '/assets/images/logoSmall.png',
    occupancy: [
      {
        adult: 2,
        child: 0,
      },
      {
        adult: 3,
        child: 0,
      },
      {
        adult: 2,
        child: 1,
      },
      {
        adult: 2,
        child: 2,
      },
      {
        adult: 2,
        child: 0,
      },
      {
        adult: 3,
        child: 0,
      },
      {
        adult: 2,
        child: 1,
      },
      {
        adult: 2,
        child: 2,
      },
    ],
    boardBasis: [
      'full_board',
      'sleep_only',
      'breakfast_kidush',
      'all_include',
      'breakfast',
      'half_board',
      'half_board_kosher',
      'full_board',
      'sleep_only',
      'breakfast_kidush',
      'all_include',
      'breakfast',
      'half_board',
      'half_board_kosher',
    ],
    dateFormat: 'DD/MM/YYYY',
    companyInfo: {
      title: 'SKY 360',
      value:
        'סקיי 360 הינה חברה העוסקת בתחום תעופה,תיירות נכנסת ופיתוח מערכות ענן הנותנות פתרונות טכנולוגיים בעולם התיירות. לפרטים נוספים בקרו באתר הבית https://www.sky360.co.il/',
      address: 'ויצמן 24, נתניה',
    },
    defaultDate: {
      from: 30,
      range: 4,
    },
    destinations: {
      local: [],
      abroad: [
        {
          label: 'טאבה הייטס - סיני ',
          value: 3419,
        },
        {
          label: 'בוקרשט - רומניה',
          value: 3421,
        },
        {
          label: 'קפריסין - לרנקה',
          value: 'LCA',
        },
        {
          label: 'לימסול - קפריסין',
          value: 3425,
        },
        {
          label: 'פרוטראס - קפריסין',
          value: 3428,
        },
        {
          label: 'אתונה - יוון ',
          value: 3400,
        },
        {
          label: 'לוטרקי - יוון ',
          value: 3418,
        },
        {
          label: 'טאבה הייטס - סיני ',
          value: 3419,
        },
        {
          label: 'בוקרשט - רומניה',
          value: 3421,
        },
        {
          label: 'קפריסין - לרנקה',
          value: 'LCA',
        },
        {
          label: 'לימסול - קפריסין',
          value: 3425,
        },
        {
          label: 'פרוטראס - קפריסין',
          value: 3428,
        },
        {
          label: 'אתונה - יוון ',
          value: 3400,
        },
        {
          label: 'לוטרקי - יוון ',
          value: 3418,
        },
      ],
    },
    searchConfig: {
      hotels: {
        favorite_locations: [],
      },
      flights: {
        defaultDeparture: {
          label: 'תל אביב',
          value: 'TLV',
        },
        favorite_locations: [
          {
            label: 'תל אביב',
            value: 'TLV',
          },
          {
            label: 'תל אביב',
            value: 'TLV',
          },
        ],
      },
      packages: {
        ts_type: 2,
        favorite_locations: [],
        enable_calender_price_api: true,
      },
      sky_packages: {
        ts_type: 1,
        favorite_locations: [],
        enable_calender_price_api: false,
      },
    },
    accessibility: {
      siteKey: '626d35b8ef43fa21b58e4940cf93052a',
    },
    parentWebsite: '4',
    defaultDeparture: 'TLV',
    leadingMainImage: '',
    id: 10,
    shareB2C: {
      dp: 5,
      cashback: {
        is_active: 1,
      },
    },
    ags: 'K2FdOKp2FUz85iwKYyY4',
    rates: {
      $: 3.261506,
      '€': 3.773174,
    },
    localInventoryDomain: 'https://groups.sky360.co.il/',
  },
  modulesConfigs: {
    DynamicPackagePage: {
      theme: {
        button: 'btn-style-5',
        tertiary: 'black',
        text_color: '#fff',
        background: '#00ccff33',
      },
      PackageDetailsConfig: {
        widgetFlights: {
          isActive: false,
          widgetSet: 'FlightsSet2',
        },
        widgetHotelInfo: {
          isActive: true,
          widgetSet: 'HotelInfoSet1',
        },
        widgetActivities: {
          theme: {
            button: 'btn-style-5',
            background: '#fff',
            tertiary: '#000000',
          },
          isActive: true,
          widgetSet: 'ActivitiesSet2',
        },
        showDates: false,
      },
      RoomPricingConfig: {
        set: 'RoomPricingSet1',
        theme: {
          button: 'btn-style-5',
          tertiary: 'black',
          background: '#00ccff33',
        },
      },
    },
    Footer: {
      set: 'FooterSet2',
      logo: '/assets/images/sky360/sky360-logo.png',
      theme: {
        tertiary: '#000',
        background: '#00CCFF',
      },
      module: 'Footer',
      columns: [
        {
          links: [
            {
              url: '/contact',
              text: 'כתבו לנו',
            },
            {
              url: '/takanon',
              text: 'תקנון האתר',
            },
            {
              url: '/passenger-info',
              text: 'מידע כללי לנוסע',
            },
            {
              url: '/privacy-info',
              text: 'מדיניות פרטיות',
            },
            {
              url: '/accessibility-info',
              text: 'הצהרת נגישות',
            },
          ],
          header: 'צור קשר',
        },
        {
          links: [
            {
              url: '/contact',
              text: 'כתבו לנו',
            },
            {
              url: '/takanon',
              text: 'תקנון האתר',
            },
            {
              url: '/passenger-info',
              text: 'מידע כללי לנוסע',
            },
            {
              url: '/privacy-info',
              text: 'מדיניות פרטיות',
            },
            {
              url: '/accessibility-info',
              text: 'הצהרת נגישות',
            },
          ],
          header: 'צור קשר',
        },
      ],
      widgetScrollToTop: {
        isActive: true,
      },
    },
    Header: {
      set: 'HeaderSet3',
      logo: '/assets/images/sky360/sky360-logo.png',
      links: [],
      theme: [],
      module: 'Header',
      widgetLangs: {
        isActive: true,
      },
      widgetSocial: {
        socials: [],
        isActive: false,
      },
      HeaderSet3Config: {
        designClass: 'header-float2',
      },
    },
    OrderNow: {
      theme: {
        background: '#42595d',
      },
      module: 'OrderNow',
    },
    RoomInfo: {
      set: 'RoomInfoSet1',
      theme: {
        title: 'title-style-1',
      },
      module: 'RoomInfo',
      facilities: [
        'TV',
        'Telephone',
        'Card',
        'Bed',
        'Radio',
        'BreakFast',
        'Porter',
        'FiveStar',
        'Juice',
        'HouseKeeping',
        'DoNotDisturb',
        'Hostess',
        'TV',
        'Telephone',
        'Card',
        'Bed',
        'Radio',
        'BreakFast',
        'Porter',
        'FiveStar',
        'Juice',
        'HouseKeeping',
        'DoNotDisturb',
        'Hostess',
      ],
      widgetRoomDetails: {
        isActive: true,
      },
      widgetRoomPictures: {
        isActive: true,
      },
      widgetRoomFacilities: {
        isActive: true,
      },
    },
    ContactUs: {
      img: 'https://www.africanbusinessreview.co.za/wp-content/uploads/2021/06/take-a-vacation.jpeg',
      set: 'ContactUsSet2',
      theme: {
        title: 'title-style-5',
        button: 'btn-style-5',
        tertiary: 'black',
      },
      title: 'צרו איתנו קשר.',
      module: 'ContactUs',
      titleLineTwo: 'צרו איתנו קשר.  נשמח לעזור לכם להזמין חופשה מושלמת.',
    },
    HotelPage: {
      RoomPricingConfig: {
        set: 'RoomPricingSet1',
      },
      PackageDetailsConfig: {
        showDates: false,
        widgetFlights: {
          isActive: false,
          widgetSet: 'FlightsSet2',
        },
        widgetHotelInfo: {
          isActive: true,
          widgetSet: 'HotelInfoSet2',
        },
        widgetActivities: {
          theme: {
            button: 'btn-style-5',
            tertiary: '#000000',
            background: '#fff',
          },
          isActive: true,
          widgetSet: 'ActivitiesSet2',
        },
      },
    },
    PromoPage: {
      module: 'PromoPage',
      packageListConfig: {
        set: 'PackageListViewSet2',
        stylesName: 'packageBox3',
        backgroundType: 'type1',
        widgetFilterMenu: {
          isActive: false,
        },
        widgetMorePackages: {
          isActive: false,
        },
        widgetPackageBoxHeader: {
          title: '',
          isActive: true,
        },
      },
    },
    Activities: {
      set: 'ActivitiesSet1',
      theme: {
        tertiary: 'black',
      },
      module: 'Activities',
    },
    FlightList: {
      set: 'FlightListSet2',
      text: 'Flight list',
      theme: [],
      title: 'טיסות ברגע האחרון',
      module: 'FlightList',
      className: 'flight-list-view',
      allow_edit: true,
      description: "Flight List's configuration",
      defaultFilters: {
        type: 'dynamic',
        adult: '2',
        limit: 8,
        prvmd: '0',
        tsType: 2,
        unique: '1',
        from_date: '23/06/2024',
        start_from: '7',
        destination: [
          'LCA',
          'RHO',
          'ATH',
          'LCA',
          'RHO',
          'ATH',
          'LCA',
          'RHO',
          'ATH',
          'LCA',
          'RHO',
          'ATH',
        ],
        return_date: '27/06/2024',
        to_week_day: 4,
        result_cache: '1',
        from_week_day: 1,
      },
      FlightListSet2Config: {
        title: 'Flight from',
        buttonUrl: '/flights',
        buttonText: 'Additional flights',
        backgroundImg: '',
      },
      availableForPageTypes: ['flight_page', 'all', 'flight_page', 'all'],
    },
    ViewFlight: {
      theme: {
        tertiary: '#7d7f8b',
        secondary: '#53cff7',
        background: '#E1F8FC',
      },
    },
    BannerLarge: {
      img: '/assets/images/famflight.png',
      set: 'BannerSet1',
      button: false,
      module: 'BannerLarge',
      backSize: 'contain',
      contentWidth: true,
    },
    Description: {
      img: 'https://www.africanbusinessreview.co.za/wp-content/uploads/2021/06/take-a-vacation.jpeg',
      theme: {
        title: 'title-style-2',
      },
      module: 'Description',
      description: 'המקום המושלם לחופש, שקט והנאה למשפחות.',
    },
    ImgCarousel: {
      theme: {
        title: 'title-style-1',
      },
      module: 'ImgCarousel',
      carousel: [
        {
          img: 'https://www.africanbusinessreview.co.za/wp-content/uploads/2021/06/take-a-vacation.jpeg',
          text: 'צימר רמת הגולן המקום המושלם.',
        },
        {
          img: 'https://cdn2.hubspot.net/hubfs/439788/Blog/Featured%20Images/Best%20Hotel%20Website%20Designs.jpg',
          text: 'צימר רמת הגולן המקום המושלם.',
        },
        {
          img: 'https://www.africanbusinessreview.co.za/wp-content/uploads/2021/06/take-a-vacation.jpeg',
          text: 'צימר רמת הגולן המקום המושלם.',
        },
        {
          img: 'https://cdn2.hubspot.net/hubfs/439788/Blog/Featured%20Images/Best%20Hotel%20Website%20Designs.jpg',
          text: 'צימר רמת הגולן המקום המושלם.',
        },
      ],
    },
    NotFound404: {
      image: '/assets/images/404.png',
      title: 'אופס.. הדף שחיפשת לא קיים',
      redirect_title: 'הנך מועבר לדף הבית',
      redirect_seconds: 7000,
    },
    PackagePage: {
      theme: {
        button: 'btn-style-5',
        tertiary: 'black',
        background: '#00ccff33',
        text_color: '#fff',
      },
      RoomPricingConfig: {
        set: 'RoomPricingSet1',
        theme: {
          button: 'btn-style-5',
          tertiary: 'black',
          background: '#00ccff33',
        },
      },
      PackageDetailsConfig: {
        showDates: false,
        widgetFlights: {
          isActive: true,
          widgetSet: 'FlightsSet2',
        },
        widgetHotelInfo: {
          isActive: true,
          widgetSet: 'HotelInfoSet1',
        },
        widgetActivities: {
          theme: {
            button: 'btn-style-5',
            tertiary: '#000000',
            background: '#fff',
          },
          isActive: true,
          widgetSet: 'ActivitiesSet2',
        },
      },
    },
    RoomPricing: {
      theme: {
        button: 'btn-style-5',
        tertiary: 'black',
      },
    },
    HotelDetails: {
      theme: {
        button: 'btn-style-5',
        tertiary: 'black',
        background: '#00ccff33',
      },
      widgetHotelInfo: {
        isActive: true,
        widgetSet: 'HotelInfoSet1',
      },
      widgetDatePicker: {
        isActive: true,
        widgetSet: 'HotelDatePickerSet1',
      },
    },
    FlightListOld: {
      theme: [],
      title: 'טיסות ברגע האחרון',
      defaultFilters: {
        type: 'dynamic',
        adult: '1',
        limit: 8,
        prvmd: '0',
        tsType: 2,
        unique: '1',
        from_date: '23/06/2024',
        start_from: '7',
        destination: ['LCA', 'RHO', 'ATH', 'LCA', 'RHO', 'ATH'],
        return_date: '27/06/2024',
        to_week_day: 4,
        result_cache: '1',
        from_week_day: 1,
      },
    },
    Banner_5ef7df1: {
      set: 'BannerSet1',
      text: 'Banner',
      theme: {
        secondary: '#00ccff',
        background: '#00ccff33',
      },
      title: 'טיסות עם החברות הישראליות',
      button: false,
      inputs: [
        {
          col: 12,
          name: 'backgroundImg',
          type: 9,
          label: 'Background Image',
          className: 'background-input',
          is_required: false,
          defaultValue: '/assets/images/searchDatepickerPackground.jpg',
        },
        {
          col: 24,
          name: 'title',
          type: 0,
          label: 'Title',
          is_required: false,
        },
        {
          col: 24,
          name: 'link',
          type: 0,
          label: 'Link',
          is_required: false,
        },
        {
          col: 24,
          name: 'blockFreeUser',
          type: 13,
          label: 'Block Free User',
          is_required: false,
          defaultValue: true,
        },
        {
          col: 24,
          name: ['styling', 'backgroundColor'],
          type: 21,
          label: 'Background color',
          className: 'theme-input',
          is_required: false,
        },
        {
          col: 24,
          name: ['styling', 'color'],
          type: 21,
          label: 'Text Color',
          className: 'theme-input',
          is_required: false,
        },
        {
          col: 24,
          name: ['styling', 'borderRadius'],
          type: 22,
          label: 'Border Radius',
          props: {
            addonAfter: 'px',
          },
          is_required: false,
        },
        {
          col: 24,
          name: ['styling', 'border'],
          type: 22,
          label: 'Border Width',
          props: {
            addonAfter: 'px',
          },
          is_required: false,
        },
        {
          col: 12,
          name: 'backgroundImg',
          type: 9,
          label: 'Background Image',
          className: 'background-input',
          is_required: false,
          defaultValue: '/assets/images/searchDatepickerPackground.jpg',
        },
        {
          col: 24,
          name: 'title',
          type: 0,
          label: 'Title',
          is_required: false,
        },
        {
          col: 24,
          name: 'link',
          type: 0,
          label: 'Link',
          is_required: false,
        },
        {
          col: 24,
          name: 'blockFreeUser',
          type: 13,
          label: 'Block Free User',
          is_required: false,
          defaultValue: true,
        },
        {
          col: 24,
          name: ['styling', 'backgroundColor'],
          type: 21,
          label: 'Background color',
          className: 'theme-input',
          is_required: false,
        },
        {
          col: 24,
          name: ['styling', 'color'],
          type: 21,
          label: 'Text Color',
          className: 'theme-input',
          is_required: false,
        },
        {
          col: 24,
          name: ['styling', 'borderRadius'],
          type: 22,
          label: 'Border Radius',
          props: {
            addonAfter: 'px',
          },
          is_required: false,
        },
        {
          col: 24,
          name: ['styling', 'border'],
          type: 22,
          label: 'Border Width',
          props: {
            addonAfter: 'px',
          },
          is_required: false,
        },
      ],
      module: 'Banner',
      styling: {
        color: '#fff',
        border: '2px solid red',
        borderRadius: '20px',
        backgroundColor: '#00ccff',
      },
      backSize: 'contain',
      instance: 'Banner_5ef7df1',
      className: 'banner-view',
      allow_edit: true,
      description: "Banner's configuration",
      contentWidth: true,
      backgroundImg:
        'uploads/8/Website/dummy_1748951762683ee2d2aa5830.79468863.png',
      blockFreeUser: false,
      backgroundType: 'type1',
      availableForPageTypes: ['all', 'all'],
    },
    PackageDetails: {
      theme: {
        button: 'btn-style-5',
        tertiary: '#000000',
      },
      widgetFlights: {
        isActive: true,
        widgetSet: 'FlightsSet2',
      },
      widgetHotelInfo: {
        isActive: true,
        widgetSet: 'HotelInfoSet2',
      },
      widgetActivities: {
        isActive: true,
        widgetSet: 'ActivitiesSet2',
      },
    },
    BannerLargeGirl: {
      img: '/assets/images/baby-girl.png',
      key: 'BannerLargeGirl',
      set: 'BannerSet2',
      theme: {
        background: '#00CCFF',
      },
      button: false,
      module: 'BannerLarge',
      textLine1: 'נופש בחגים זה אנחנו.',
    },
    DatesSuggestion: {
      url: '#',
      theme: {
        title: 'title-style-2',
      },
      title: 'תאריכי חופשה',
      module: 'DatesSuggestion',
      buttonText: 'לעוד דילים טובים ›',
      titleLineTwo: 'פופולאריים',
    },
    DestinationList: {
      set: 'DestinationListSet1',
      title: 'היעדים שלנו',
      linkType: 'packageSearch',
    },
    PackageListView: {
      set: 'PackageListViewSet3',
      text: 'Package List',
      theme: {
        secondary: '#00ccff',
        background: '#00ccff33',
      },
      title: 'Package List',
      boxSet: 'packageBoxWithGallery',
      module: 'PackageListView',
      className: 'package-list-view',
      allow_edit: true,
      description: 'Package List',
      backgroundType: 'type1',
      defaultFilters: {
        type: 'dynamic',
        adult: '1',
        limit: 6,
        prvmd: '0',
        tsType: 2,
        unique: '1',
        ts_type: '2',
        from_date: '23/06/2024',
        start_from: '20',
        destination: 'RHO,LCA,SVO,KLU,CWC,PNY,HMO,ZZH,HRR,HN1,AHO',
        return_date: '27/06/2024',
        to_week_day: 4,
        result_cache: '1',
        from_week_day: 0,
      },
      widgetFilterMenu: {
        isActive: false,
      },
      widgetMorePackages: {
        isActive: false,
      },
      availableForPageTypes: ['package_page', 'all', 'package_page', 'all'],
      widgetPackageBoxHeader: {
        title: 'הדילים החמים - יולי אוגוסט משפחות!',
        isActive: false,
      },
      PackageListViewSet3Config: {
        lead_image: '',
        lead_title: 'הדילים החמים - יולי אוגוסט ',
        lead_button_text: 'Additional packages',
        use_images_from_products: false,
      },
    },
    BannerLargePalms: {
      img: '/assets/images/bannerPalms.png',
      key: 'BannerLargePalms',
      set: 'BannerSet3',
      button: true,
      module: 'BannerLarge',
      textLine1: 'נופש בחגים זה אנחנו.',
      buttonText: 'תנו קפיצה לקיץ',
      contentWidth: true,
    },
    HotelRoomPricing: {
      theme: {
        button: 'btn-style-5',
        tertiary: 'black',
        background: '#00ccff33',
      },
    },
    SearchDatePicker: {
      set: 'SearchDatePickerSmallPackage',
      theme: {
        title: 'title-style-1',
      },
      module: 'SearchDatePicker',
      showSearchResults: {
        isActive: true,
      },
      widgetVacationTypes: {
        isActive: false,
      },
      widgetDatePickerCarousel: {
        isActive: false,
      },
    },
    FlightList_e552abd: {
      set: 'FlightListSet2',
      text: 'Flight list',
      title: 'מהרו להזמין',
      inputs: [
        {
          col: 24,
          name: 'title',
          type: 0,
          label: 'Title',
          is_required: false,
        },
        {
          col: 24,
          name: 'defaultFilters',
          type: 19,
          dictionary: 'ts_type_flights',
          is_required: false,
          autocompleteMode: 'airport',
        },
        {
          col: 24,
          name: 'defaultFilters',
          type: 17,
          is_required: false,
        },
        {
          col: 24,
          name: 'theme',
          type: 10,
          label: 'Theme',
          className: 'theme-input',
          is_required: false,
        },
        {
          col: 24,
          name: 'title',
          type: 0,
          label: 'Title',
          is_required: false,
        },
        {
          col: 24,
          name: 'defaultFilters',
          type: 19,
          dictionary: 'ts_type_flights',
          is_required: false,
          autocompleteMode: 'airport',
        },
        {
          col: 24,
          name: 'defaultFilters',
          type: 17,
          is_required: false,
        },
        {
          col: 24,
          name: 'theme',
          type: 10,
          label: 'Theme',
          className: 'theme-input',
          is_required: false,
        },
      ],
      module: 'FlightList',
      instance: 'FlightList_e552abd',
      className: 'flight-list-view',
      setInputs: [
        {
          id: 'FlightListSet1',
          name: 'flights row promotion',
          description: 'this promotion modules is row based',
        },
        {
          id: 'FlightListSet2',
          name: 'flights column promotion',
          description: 'this promotion modules is column based',
          additionalConfig: {
            inputs: [
              {
                col: 24,
                name: 'title',
                type: 0,
                label: 'Title',
                is_required: false,
              },
              {
                col: 24,
                name: 'buttonText',
                type: 0,
                label: 'Button Text',
                is_required: false,
              },
              {
                col: 24,
                name: 'buttonUrl',
                type: 23,
                label: 'Button URL',
                is_required: false,
              },
              {
                col: 24,
                name: 'backgroundImg',
                type: 9,
                label: 'Background Image',
                is_required: false,
              },
            ],
          },
        },
        {
          id: 'FlightListSet1',
          name: 'flights row promotion',
          description: 'this promotion modules is row based',
        },
        {
          id: 'FlightListSet2',
          name: 'flights column promotion',
          description: 'this promotion modules is column based',
          additionalConfig: {
            inputs: [
              {
                col: 24,
                name: 'title',
                type: 0,
                label: 'Title',
                is_required: false,
              },
              {
                col: 24,
                name: 'buttonText',
                type: 0,
                label: 'Button Text',
                is_required: false,
              },
              {
                col: 24,
                name: 'buttonUrl',
                type: 23,
                label: 'Button URL',
                is_required: false,
              },
              {
                col: 24,
                name: 'backgroundImg',
                type: 9,
                label: 'Background Image',
                is_required: false,
              },
            ],
          },
        },
      ],
      allow_edit: true,
      description: "Flight List's configuration",
      defaultFilters: {
        type: 'dynamic',
        adult: '1',
        limit: 6,
        tsType: 2,
        unique: '1',
        start_from: '7',
        destination: ['LCA', 'RHO', 'ATH', 'LCA', 'RHO', 'ATH'],
        to_week_day: 4,
        result_cache: '1',
        from_week_day: 0,
      },
      FlightListSet2Config: {
        title: 'טיסות החל מ',
        buttonUrl: '/flights',
        buttonText: 'לטיסות נוספת',
        backgroundImg:
          'uploads/8/Website/dummy_1748951478683ee1b6eeea70.41367041.png',
      },
      availableForPageTypes: ['flight_page', 'all', 'flight_page', 'all'],
    },
    PackageListViewOld: {
      set: 'PackageListViewSet3',
      text: 'Package List',
      theme: {
        secondary: '#00ccff',
        background: '#00ccff33',
      },
      title: 'Package List',
      boxSet: 'packageBoxWithGallery',
      module: 'PackageListView',
      className: 'package-list-view',
      allow_edit: true,
      description: 'Package List',
      backgroundType: 'type1',
      defaultFilters: {
        type: 'dynamic',
        adult: '1',
        limit: 6,
        prvmd: '0',
        tsType: 2,
        unique: '1',
        ts_type: '2',
        from_date: '23/06/2024',
        start_from: '20',
        destination: 'RHO,LCA,HER,SVO,KLU,CWC,PNY,HMO,ZZH,HRR,HN1,AHO',
        return_date: '27/06/2024',
        to_week_day: 5,
        result_cache: '1',
        from_week_day: 1,
      },
      widgetFilterMenu: {
        isActive: false,
      },
      widgetMorePackages: {
        isActive: false,
      },
      availableForPageTypes: ['package_page', 'all', 'package_page', 'all'],
      widgetPackageBoxHeader: {
        title: 'הדילים החמים - יולי אוגוסט משפחות!',
        isActive: false,
      },
      PackageListViewSet3Config: {
        lead_image: '',
        lead_title: 'Vacation Packages',
        lead_button_text: 'Additional packages',
        use_images_from_products: false,
      },
    },
    PackageRoomPricing: {
      theme: {
        button: 'btn-style-5',
        tertiary: 'black',
      },
    },
    PageContentAboutUs: {
      set: 'PageContentSet1',
      theme: {
        title: 'title-style-5',
        button: 'btn-style-5',
        tertiary: 'black',
      },
      title: 'צרו איתנו קשר.',
      module: 'PageContent',
      desc_id: 3,
    },
    PageContentPrivacy: {
      set: 'PageContentSet1',
      theme: {
        title: 'title-style-5',
        button: 'btn-style-5',
        tertiary: 'black',
      },
      title: 'מדיניות פרטיות',
      module: 'PageContent',
      desc_type: 'privacy',
    },
    PageContentTakanon: {
      set: 'PageContentSet1',
      theme: {
        title: 'title-style-5',
        button: 'btn-style-5',
        tertiary: 'black',
      },
      title: 'תקנון האתר',
      module: 'PageContent',
      desc_type: 'terms',
    },
    PackageSearchConfig: {
      features: {
        SKI: {
          isActive: 1,
          backimage: '/assets/images/mFeature-background/ski.jpg',
        },
        SPA: {
          isActive: 1,
          backimage: '/assets/images/mFeature-background/spa.jpg',
        },
        TOUR: {
          isActive: 1,
          backimage: '/assets/images/mFeature-background/tour.jpg',
        },
        EVENT: {
          isActive: 1,
          backimage: '/assets/images/mFeature-background/event.jpg',
        },
        SPORT: {
          isActive: 1,
          backimage: '/assets/images/mFeature-background/sport.jpg',
        },
        'FLT+HTL+CAR': {
          isActive: 1,
          backimage: '/assets/images/mFeature-background/flt+htl+car.jpg',
        },
        'YOUNG VACATION': {
          isActive: 1,
          backimage: '/assets/images/mFeature-background/young.jpg',
        },
        EVENT_PREMIUM: {
          isActive: 1,
          backimage: '/assets/images/mFeature-background/event.jpg',
        },
      },
    },
    ActivitiesSuggestion: {
      url: '#',
      theme: {
        title: 'title-style-3',
      },
      title: 'אטרקציות וחוויות',
      module: 'ActivitiesSuggestion',
      buttonText: 'לכל האטרקציות ›',
      titleLineTwo: 'בקרבת מקום',
    },
    DestinationListLight: {
      set: 'DestinationListLightSet3',
      title: 'היעדים שלנו',
      linkType: 'packageSearch',
    },
    PageContentPassenger: {
      set: 'PageContentSet1',
      theme: {
        title: 'title-style-5',
        button: 'btn-style-5',
        tertiary: 'black',
      },
      title: 'מידע לנוסע',
      module: 'PageContent',
      desc_type: 'passenger_info',
    },
    ProductFilterMainPage: {
      module: 'SwitchDatePicker',
      searchOptions: 'packages,flights,hotels,attractions,events',
      // default_package_type: 'DP', // "DP" or "ALP"
      default_package_type: undefined, // "DP" or "ALP"
      hide_regular_packages: false,
      // isDynamicPackageSearchWithEvents: false,
      showSearchResults: {
        isActive: false,
      },
    },
    PackageListViewFilters: {
      set: 'PackageListViewSet2',
      theme: {
        button: 'btn-style-5',
      },
      module: 'PackageListView',
      stylesName: 'packageBox3',
      backgroundType: false,
      widgetFilterMenu: {
        title: 'חבילות נופש לכל המשפחה',
        isActive: true,
        listFilters: [
          {
            name: 'מאמיה',
            filters: {
              dates: '14/07/2023-01/09/2023',
              limit: '6',
              destination: '3423',
            },
          },
          {
            name: 'קפריסין הצפונית',
            filters: {
              dates: '01/05/2023-01/09/2023',
              limit: '6',
              destination: '3396',
            },
          },
          {
            name: 'מחירים מיוחדים יולי',
            filters: {
              dates: '01/07/2023-01/08/2023',
              limit: '12',
              source: 'alp',
              feature: 'cruise',
            },
          },
          {
            name: 'חופשה עם הילדים',
            filters: {
              dates: '01/08/2023-01/09/2023',
              limit: '12',
            },
          },
          {
            name: 'מאמיה',
            filters: {
              dates: '14/07/2023-01/09/2023',
              limit: '6',
              destination: '3423',
            },
          },
          {
            name: 'קפריסין הצפונית',
            filters: {
              dates: '01/05/2023-01/09/2023',
              limit: '6',
              destination: '3396',
            },
          },
          {
            name: 'מחירים מיוחדים יולי',
            filters: {
              dates: '01/07/2023-01/08/2023',
              limit: '12',
              source: 'alp',
              feature: 'cruise',
            },
          },
          {
            name: 'חופשה עם הילדים',
            filters: {
              dates: '01/08/2023-01/09/2023',
              limit: '12',
            },
          },
        ],
        titleLineTwo: 'ביעדים והמלונות שלנו!',
      },
      widgetMorePackages: {
        isActive: true,
      },
      widgetPackageBoxHeader: {
        isActive: false,
      },
    },
    PromotionBoxes_26ef752: {
      text: 'PromotionBoxes',
      title: 'המומלצים של SKY 360',
      module: 'PromotionBoxes',
      instance: 'PromotionBoxes_26ef752',
      LineBoxes: '7',
      allow_edit: true,
      description: 'PromotionBoxes configuration',
      PromotionBoxes: [
        {
          link: {
            id: 18,
            type: 'dp_link',
            secret: ' תאילנד-זוגות',
            new_tab: true,
            page_type: 'promotion',
          },
          image:
            'https://stg-files-upload.s3.eu-central-1.amazonaws.com/uploads/8/Website/thumbs/dummy_17482391236834031359ec10.55933674.jpg',
          title: 'חבילות נופש לימסול ',
          buttonTitle: '',
          description: '',
        },
        {
          link: {
            id: 17,
            type: 'dp_link',
            secret: '35322db7-7',
            new_tab: true,
            page_type: 'promotion',
          },
          image:
            'https://stg-files-upload.s3.eu-central-1.amazonaws.com/uploads/8/Website/thumbs/dummy_17482391676834033fa2c756.59360280.jpeg',
          title: 'לימסול - חופשה לכל המשפחה!',
          buttonTitle: '',
          description: '',
        },
        {
          link: {
            type: 'prom',
            secret: 'NEW_P',
            new_tab: true,
          },
          image:
            'https://stg-files-upload.s3.eu-central-1.amazonaws.com/uploads/8/Website/thumbs/dummy_17492395826843471e1b8021.88687553.jpg',
          title: 'tytyt',
        },
        {
          link: {
            type: 'prom',
            secret: 'PEOM_MAMI',
            new_tab: true,
          },
          image:
            'https://stg-files-upload.s3.eu-central-1.amazonaws.com/uploads/8/Website/thumbs/dummy_1749374133684554b59aaaa9.60823076.jpeg',
          title: 'חבילות עם ספא',
          buttonTitle: '',
          description: 'ddasa',
        },
        {
          link: {
            type: 'prom',
            secret: 'PEOM_MAMI',
            new_tab: false,
          },
          image:
            'https://stg-files-upload.s3.eu-central-1.amazonaws.com/uploads/8/Website/thumbs/dummy_174963819468495c32dabec8.73172854.jpg',
          title: 'חבילות נופש מיוחדות',
        },
        {
          link: {
            id: 18,
            type: 'dp_link',
            secret: ' תאילנד-זוגות',
            new_tab: true,
            page_type: 'promotion',
          },
          image:
            'https://stg-files-upload.s3.eu-central-1.amazonaws.com/uploads/8/Website/thumbs/dummy_17482391236834031359ec10.55933674.jpg',
          title: 'חבילות נופש לימסול ',
          buttonTitle: '',
          description: '',
        },
        {
          link: {
            id: 17,
            type: 'dp_link',
            secret: '35322db7-7',
            new_tab: true,
            page_type: 'promotion',
          },
          image:
            'https://stg-files-upload.s3.eu-central-1.amazonaws.com/uploads/8/Website/thumbs/dummy_17482391676834033fa2c756.59360280.jpeg',
          title: 'לימסול - חופשה לכל המשפחה!',
          buttonTitle: '',
          description: '',
        },
        {
          link: {
            type: 'prom',
            secret: 'NEW_P',
            new_tab: true,
          },
          image:
            'https://stg-files-upload.s3.eu-central-1.amazonaws.com/uploads/8/Website/thumbs/dummy_17492395826843471e1b8021.88687553.jpg',
          title: 'tytyt',
        },
        {
          link: {
            type: 'prom',
            secret: 'PEOM_MAMI',
            new_tab: true,
          },
          image:
            'https://stg-files-upload.s3.eu-central-1.amazonaws.com/uploads/8/Website/thumbs/dummy_1749374133684554b59aaaa9.60823076.jpeg',
          title: 'חבילות עם ספא',
          buttonTitle: '',
          description: 'ddasa',
        },
        {
          link: {
            type: 'prom',
            secret: 'PEOM_MAMI',
            new_tab: false,
          },
          image:
            'https://stg-files-upload.s3.eu-central-1.amazonaws.com/uploads/8/Website/thumbs/dummy_174963819468495c32dabec8.73172854.jpg',
          title: 'חבילות נופש מיוחדות',
        },
      ],
      isScrollableList: 1,
      isIncludeBoxTitle: 0,
      availableForPageTypes: [
        'attraction_page',
        'all',
      ],
    },
    PackageListViewNextWeek: {
      set: 'PackageListViewSet2',
      module: 'PackageListView',
      stylesName: 'packageBox4',
      backgroundType: false,
      defaultFilters: {
        dates: {
          from: 7,
          range: 21,
        },
        limit: 3,
        staticFilter: 'type=upcoming',
      },
      widgetFilterMenu: {
        isActive: false,
      },
      widgetMorePackages: {
        isActive: false,
      },
      widgetPackageBoxHeader: {
        title: 'כמה אתם ספונטנים?',
        isActive: true,
      },
    },
    PackageListView_46a25d2: {
      set: 'PackageListViewSet2',
      text: 'Package List',
      theme: {
        secondary: '#00ccff',
        background: '#00ccff33',
      },
      title: 'Package List',
      boxSet: 'packageBoxWithGallery',
      inputs: [
        {
          col: 24,
          name: ['widgetPackageBoxHeader', 'title'],
          type: 0,
          label: 'Title',
          is_required: false,
        },
        {
          col: 24,
          name: 'defaultVendor',
          type: 19,
          dictionary: 'ts_type_packages',
          is_required: false,
          autocompleteMode: 'ts',
        },
        {
          col: 24,
          name: 'defaultFilters',
          type: 17,
          is_required: false,
        },
        {
          col: 24,
          name: 'theme',
          type: 10,
          label: 'Theme',
          className: 'theme-input',
          is_required: false,
        },
        {
          col: 24,
          name: ['widgetPackageBoxHeader', 'title'],
          type: 0,
          label: 'Title',
          is_required: false,
        },
        {
          col: 24,
          name: 'defaultVendor',
          type: 19,
          dictionary: 'ts_type_packages',
          is_required: false,
          autocompleteMode: 'ts',
        },
        {
          col: 24,
          name: 'defaultFilters',
          type: 17,
          is_required: false,
        },
        {
          col: 24,
          name: 'theme',
          type: 10,
          label: 'Theme',
          className: 'theme-input',
          is_required: false,
        },
      ],
      module: 'PackageListView',
      instance: 'PackageListView_46a25d2',
      className: 'package-list-view',
      setInputs: [
        {
          id: 'PackageListViewSet1',
          name: 'packages row promotion1',
          description: 'this promotion modules is row based',
        },
        {
          id: 'PackageListViewSet2',
          name: 'packages row promotion2',
          description: 'this promotion modules is row based',
        },
        {
          id: 'PackageListViewSet3',
          name: 'packages column promotion',
          description: 'this promotion modules is column based',
          additionalConfig: {
            inputs: [
              {
                col: 24,
                name: 'lead_title',
                type: 0,
                label: 'Lead Title',
                is_required: false,
              },
              {
                col: 24,
                name: 'lead_button_text',
                type: 0,
                label: 'Lead Button Text',
                is_required: false,
              },
              {
                col: 24,
                name: 'use_images_from_products',
                type: 13,
                label: 'Use images from products',
                is_required: false,
              },
              {
                col: 24,
                name: 'lead_image',
                type: 9,
                label: 'Lead Image',
                is_required: false,
              },
              {
                col: 24,
                name: 'buttonUrl',
                type: 23,
                label: 'Button URL',
                is_required: false,
              },
            ],
          },
        },
        {
          id: 'PackageListViewSet1',
          name: 'packages row promotion1',
          description: 'this promotion modules is row based',
        },
        {
          id: 'PackageListViewSet2',
          name: 'packages row promotion2',
          description: 'this promotion modules is row based',
        },
        {
          id: 'PackageListViewSet3',
          name: 'packages column promotion',
          description: 'this promotion modules is column based',
          additionalConfig: {
            inputs: [
              {
                col: 24,
                name: 'lead_title',
                type: 0,
                label: 'Lead Title',
                is_required: false,
              },
              {
                col: 24,
                name: 'lead_button_text',
                type: 0,
                label: 'Lead Button Text',
                is_required: false,
              },
              {
                col: 24,
                name: 'use_images_from_products',
                type: 13,
                label: 'Use images from products',
                is_required: false,
              },
              {
                col: 24,
                name: 'lead_image',
                type: 9,
                label: 'Lead Image',
                is_required: false,
              },
              {
                col: 24,
                name: 'buttonUrl',
                type: 23,
                label: 'Button URL',
                is_required: false,
              },
            ],
          },
        },
      ],
      allow_edit: true,
      description: 'Package List',
      backgroundType: 'type1',
      defaultFilters: {
        type: 'dynamic',
        adult: '1',
        limit: 6,
        prvmd: '0',
        tsType: 2,
        unique: '1',
        ts_type: '2',
        from_date: '23/06/2024',
        start_from: '20',
        destination: 'RHO,LCA,HER,SVO,KLU,CWC,PNY,HMO,AHO',
        return_date: '27/06/2024',
        to_week_day: 5,
        result_cache: '1',
        from_week_day: 1,
        is_special: 0,
      },
      widgetFilterMenu: {
        isActive: false,
      },
      widgetMorePackages: {
        isActive: false,
      },
      availableForPageTypes: ['package_page', 'all', 'package_page', 'all'],
      widgetPackageBoxHeader: {
        title: 'הדילים החמים - יולי אוגוסט משפחות!',
        isActive: true,
      },
      PackageListViewSet1Config: [],
      PackageListViewSet2Config: [],
      PackageListViewSet3Config: {
        buttonUrl: [],
        lead_image: '',
        lead_title: 'Vacation Packages',
        lead_button_text: 'Additional packages',
        use_images_from_products: true,
      },
    },
    PageContentAccessibility: {
      set: 'PageContentSet1',
      theme: {
        title: 'title-style-5',
        button: 'btn-style-5',
        tertiary: 'black',
      },
      title: 'הצהרת נגישות',
      module: 'PageContent',
      desc_type: 'accessibility',
    },
    SearchDatePickerMainPage: {
      set: 'SearchDatePickerSet2',
      theme: {
        title: 'title-style-1',
      },
      module: 'SearchDatePicker',
      backgroundImg: '/assets/images/searchDatepickerPackground.jpg',
      searchOptions: [
        'hotel',
        'package',
        'flights',
        'hotel',
        'package',
        'flights',
      ],
      showSearchResults: {
        isActive: false,
      },
      widgetVacationTypes: {
        isActive: false,
      },
      widgetDatePickerCarousel: {
        isActive: false,
      },
    },
    SearchDatePickerHotelPage: {
      set: 'SearchDatePicketSwitcher',
      theme: {
        title: 'title-style-1',
        background: '#00ccff33',
      },
      module: 'SearchDatePicker',
      setConfig: {
        promotionText:
          'בחרו מספר יעדים  בין תאריכים ונמצא לכם את החופשה המושלמת!',
      },
      flightSummary: {
        isActive: true,
      },
      searchOptions: [],
      searchResultType: 'hotels',
      showSearchResults: {
        isActive: true,
      },
      widgetVacationTypes: {
        isActive: false,
      },
      widgetDatePickerCarousel: {
        isActive: false,
      },
    },
    AttractionListView_76997c5: {
      text: 'Attraction List View',
      title: 'Attraction List View',
      inputs: [
        {
          col: 24,
          name: 'main_title',
          type: 0,
          label: 'Main Title',
          is_required: false,
        },
        {
          col: 24,
          name: 'headerTitle',
          type: 0,
          label: 'Header Title',
          is_required: false,
        },
        {
          col: 24,
          name: 'buttonText',
          type: 0,
          label: 'Button Text',
          is_required: false,
        },
        {
          col: 24,
          name: 'buttonUrl',
          type: 23,
          label: 'Button URL',
          is_required: false,
        },
        {
          col: 24,
          mode: 'city',
          name: 'destinations',
          type: 16,
          label: 'Destinations',
          is_required: false,
          autocompleteMode: 'city',
        },
        {
          col: 24,
          name: 'main_title',
          type: 0,
          label: 'Main Title',
          is_required: false,
        },
        {
          col: 24,
          name: 'headerTitle',
          type: 0,
          label: 'Header Title',
          is_required: false,
        },
        {
          col: 24,
          name: 'buttonText',
          type: 0,
          label: 'Button Text',
          is_required: false,
        },
        {
          col: 24,
          name: 'buttonUrl',
          type: 23,
          label: 'Button URL',
          is_required: false,
        },
        {
          col: 24,
          mode: 'city',
          name: 'destinations',
          type: 16,
          label: 'Destinations',
          is_required: false,
          autocompleteMode: 'city',
        },
      ],
      module: 'AttractionListView',
      instance: 'AttractionListView_76997c5',
      buttonUrl: [],
      allow_edit: true,
      buttonText: 'additionall attractions',
      main_title: 'אטרקציות ברחבי העולם',
      description: 'Attraction list configuration',
      headerTitle: 'החל מ -',
      destinations: '414091,413539',
      availableForPageTypes: [
        'attraction_page',
        'all',
      ],
    },
    SearchDatePickerFlightPage: {
      set: 'SearchDatePicketSwitcher',
      theme: {
        title: 'title-style-1',
        background: '#00ccff33',
      },
      module: 'SearchDatePicker',
      setConfig: {
        promotionText:
          'בחרו מספר יעדים  בין תאריכים ונמצא לכם את החופשה המושלמת!',
      },
      autoSearch: true,
      flightSummary: {
        isActive: true,
      },
      searchOptions: [],
      searchResultType: 'flights',
      showSearchResults: {
        isActive: true,
      },
      widgetVacationTypes: {
        isActive: false,
      },
      widgetDatePickerCarousel: {
        isActive: false,
      },
    },
    ProductFilterViewFlightPage: {
      module: 'SwitchDatePicker',
      showFilters: {
        isActive: false,
      },
      searchOptions: ['flights'],
      showSearchResults: {
        isActive: false,
      },
    },
    ProductFilterHotelSearchPage: {
      module: 'SwitchDatePicker',
      searchOptions: ['hotels'],
      showSearchResults: {
        isActive: true,
      },
    },
    SearchDatePickerWithSwitcher: {
      set: 'SearchDatePicketSwitcher',
      theme: {
        title: 'title-style-1',
        background: '#00ccff33',
      },
      module: 'SearchDatePicker',
      autoSearch: false,
      searchOptions: [
        'packages',
        'flights',
        'hotels',
        'packages',
        'flights',
        'hotels',
      ],
      searchResultType: 'packages',
      showSearchResults: {
        isActive: false,
      },
      widgetVacationTypes: {
        isActive: false,
      },
      widgetDatePickerCarousel: {
        isActive: false,
      },
    },
    ProductFilterFlightSearchPage: {
      theme: {
        primary: '#0a2a59',
        tertiary: '#7d7f8b',
        secondary: '#53cff7',
      },
      module: 'SwitchDatePicker',
      searchOptions: ['flights'],
      showSearchResults: {
        isActive: true,
      },
    },
    ProductFilterPackageSearchPage: {
      module: 'SwitchDatePicker',
      showFilters: {
        isActive: false,
      },
      searchOptions: ['packages'],
      showSearchResults: {
        isActive: true,
      },
      // isDynamicPackageSearchWithEvents: false,
    },
    SearchDatePickerFlightViewPage: {
      set: 'SearchDatePicketSwitcher',
      theme: {
        title: 'title-style-1',
        background: '#00ccff33',
      },
      module: 'SearchDatePicker',
      autoSearch: false,
      searchOptions: [],
      searchResultType: 'flights',
      showSearchResults: {
        isActive: false,
      },
      widgetVacationTypes: {
        isActive: false,
      },
      widgetDatePickerCarousel: {
        isActive: false,
      },
    },
    SearchDatePickerSearchPackagePage: {
      set: 'SearchDatePickerPackageIndex',
      theme: {
        title: 'title-style-1',
        background: '#00ccff33',
      },
      module: 'SearchDatePicker',
      setConfig: {
        promotionText:
          'בחרו מספר יעדים  בין תאריכים ונמצא לכם את החופשה המושלמת!',
      },
      searchOptions: [],
      searchResultType: 'packages',
      showSearchResults: {
        isActive: true,
      },
      widgetVacationTypes: {
        isActive: false,
      },
      widgetDatePickerCarousel: {
        isActive: false,
      },
    },
    ProductFilterAttractionsSearchPage: {
      theme: {
        primary: '#0a2a59',
        tertiary: '#7d7f8b',
        secondary: '#53cff7',
        background: '#f2f3f5',
      },
      module: 'SwitchDatePicker',
      backgroundImg: '/assets/images/sky360/main-back.jpg',
      searchOptions: ['attractions'],
      showSearchResults: {
        isActive: true,
      },
    },
    Banner_5545f08: {
      set: 'BannerSet1',
      link: [],
      text: 'Banner',
      theme: {
        secondary: '#00ccff',
        background: '#00ccff33',
      },
      title: 'Banner',
      button: false,
      module: 'Banner',
      styling: {
        color: '#fff',
        border: '2px solid red',
        borderRadius: '20px',
        backgroundColor: '#00ccff',
      },
      backSize: 'contain',
      instance: 'Banner_5545f08',
      className: 'banner-view',
      allow_edit: true,
      description: "Banner's configuration",
      contentWidth: true,
      blockFreeUser: false,
      backgroundType: 'type1',
      availableForPageTypes: ['all', 'promotion', 'destination', 'general'],
    },
    Banner_8693a35: {
      set: 'BannerSet1',
      link: [],
      text: 'Banner',
      theme: {
        secondary: '#00ccff',
        background: '#00ccff33',
      },
      title: 'Banner',
      button: false,
      module: 'Banner',
      styling: {
        color: '#fff',
        border: '2px solid red',
        borderRadius: '20px',
        backgroundColor: '#00ccff',
      },
      backSize: 'contain',
      instance: 'Banner_8693a35',
      className: 'banner-view',
      allow_edit: true,
      description: "Banner's configuration",
      contentWidth: true,
      blockFreeUser: false,
      backgroundType: 'type1',
      availableForPageTypes: ['all', 'promotion', 'destination', 'general'],
    },
    Banner_9924115: {
      set: 'BannerSet1',
      link: [],
      text: 'Banner',
      theme: {
        secondary: '#00ccff',
        background: '#00ccff33',
      },
      title: 'Banner',
      button: false,
      module: 'Banner',
      styling: {
        color: '#fff',
        border: '2px solid red',
        borderRadius: '20px',
        backgroundColor: '#00ccff',
      },
      backSize: 'contain',
      instance: 'Banner_9924115',
      className: 'banner-view',
      allow_edit: true,
      description: "Banner's configuration",
      contentWidth: true,
      blockFreeUser: false,
      backgroundType: 'type1',
      availableForPageTypes: ['all', 'promotion', 'destination', 'general'],
    },
    Banner_b852778: {
      set: 'BannerSet1',
      link: [],
      text: 'Banner',
      theme: {
        secondary: '#00ccff',
        background: '#00ccff33',
      },
      title: 'Banner',
      button: false,
      module: 'Banner',
      styling: {
        color: '#fff',
        border: '2px solid red',
        borderRadius: '20px',
        backgroundColor: '#00ccff',
      },
      backSize: 'contain',
      instance: 'Banner_b852778',
      className: 'banner-view',
      allow_edit: true,
      description: "Banner's configuration",
      contentWidth: true,
      blockFreeUser: false,
      backgroundType: 'type1',
      availableForPageTypes: ['all', 'promotion', 'destination', 'general'],
    },
    PackageListView_0b82f3a: {
      set: 'PackageListViewSet4',
      text: 'Package List',
      theme: {
        secondary: '#00ccff',
        background: '#00ccff33',
      },
      title: 'Package List',
      boxSet: 'packageBoxWithGallery',
      module: 'PackageListView',
      instance: 'PackageListView_0b82f3a',
      className: 'package-list-view',
      allow_edit: true,
      description: 'Package List',
      isSingleFetch: true,
      backgroundType: 'type1',
      defaultFilters: {
        type: 'dynamic',
        adult: '1',
        hotel: '',
        limit: 7,
        prvmd: '0',
        tsType: 2,
        unique: '1',
        feature: '',
        ts_type: '2',
        by_range: [],
        supplier: '',
        from_date: '',
        is_special: false,
        start_from: '20',
        destination: '',
        return_date: '',
        to_week_day: 5,
        result_cache: '1',
        from_week_day: 1,
      },
      widgetFilterMenu: {
        isActive: false,
      },
      widgetMorePackages: {
        isActive: false,
      },
      availableForPageTypes: [
        'package_page',
        'all',
        'promotion',
        'destination',
        'general',
      ],
      widgetPackageBoxHeader: {
        title: 'הדילים החמים..',
        isActive: true,
      },
      PackageListViewSet1Config: [],
      PackageListViewSet2Config: [],
      PackageListViewSet3Config: {
        buttonUrl: [],
        lead_image: '',
        lead_title: 'Vacation Packages',
        lead_button_text: 'Additional packages',
        use_images_from_products: true,
      },
    },
    PackageListView_1563b67: {
      set: 'PackageListViewSet2',
      text: 'Package List',
      theme: {
        secondary: '#00ccff',
        background: '#00ccff33',
      },
      title: 'Package List',
      boxSet: 'packageBoxWithGallery',
      module: 'PackageListView',
      instance: 'PackageListView_1563b67',
      className: 'package-list-view',
      allow_edit: true,
      description: 'Package List',
      isSingleFetch: true,
      backgroundType: 'type1',
      defaultFilters: {
        type: 'dynamic',
        adult: '1',
        hotel: '',
        limit: 7,
        prvmd: '0',
        tsType: 2,
        unique: '1',
        feature: '',
        ts_type: '2',
        by_range: [],
        supplier: '',
        from_date: '',
        is_special: false,
        start_from: '20',
        destination: '',
        return_date: '',
        to_week_day: 5,
        result_cache: '1',
        from_week_day: 1,
      },
      widgetFilterMenu: {
        isActive: false,
      },
      widgetMorePackages: {
        isActive: false,
      },
      availableForPageTypes: [
        'package_page',
        'all',
        'promotion',
        'destination',
        'general',
      ],
      widgetPackageBoxHeader: {
        title: 'הדילים החמים..',
        isActive: true,
      },
      PackageListViewSet1Config: [],
      PackageListViewSet2Config: [],
      PackageListViewSet3Config: {
        buttonUrl: [],
        lead_image: '',
        lead_title: 'Vacation Packages',
        lead_button_text: 'Additional packages',
        use_images_from_products: true,
      },
    },
    PackageListView_91d0d7c: {
      set: 'PackageListViewSet3',
      text: 'Package List',
      theme: {
        secondary: '#00ccff',
        background: '#00ccff33',
      },
      title: 'Package List',
      boxSet: 'packageBoxWithGallery',
      module: 'PackageListView',
      instance: 'PackageListView_91d0d7c',
      className: 'package-list-view',
      allow_edit: true,
      description: 'Package List',
      isSingleFetch: true,
      backgroundType: 'type1',
      defaultFilters: {
        type: 'dynamic',
        adult: '1',
        hotel: '',
        limit: 7,
        prvmd: '0',
        tsType: 2,
        unique: '1',
        feature: '',
        ts_type: '2',
        by_range: [],
        supplier: '',
        from_date: '',
        is_special: false,
        start_from: '20',
        destination: '',
        return_date: '',
        to_week_day: 5,
        result_cache: '1',
        from_week_day: 1,
      },
      widgetFilterMenu: {
        isActive: false,
      },
      widgetMorePackages: {
        isActive: false,
      },
      availableForPageTypes: [
        'package_page',
        'all',
        'promotion',
        'destination',
        'general',
      ],
      widgetPackageBoxHeader: {
        title: 'הדילים החמים..',
        isActive: true,
      },
      PackageListViewSet1Config: [],
      PackageListViewSet2Config: [],
      PackageListViewSet3Config: {
        buttonUrl: [],
        lead_image: '',
        lead_title: 'Vacation Packages',
        lead_button_text: 'Additional packages',
        use_images_from_products: true,
      },
    },
    PackageListView_d485168: {
      defaultFilters: {
        by_range: [],
        is_special: 0,
        destination: 'TBS',
      },
    },
  },
  pages: [
    {
      path: '/dynamicPackageSearch',
      modules: ['ProductFilterPackageSearchPage'],
      name: 'Dynamic Package Search',
      type: 'searchResultPage',
      layout: 'default',
      seo: {
        title: '',
        desc: '',
      },
    },
    {
      path: '/dynamicPackage',
      modules: ['DynamicPackagePage'],
      name: 'Dynamic Package Info',
      type: 'dynamicPackagePage',
      layout: 'default',
      seo: {
        title: '',
        desc: '',
      },
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Attractions Search',
      path: ['/attractions'],
      type: 'searchResultPage',
      layout: 'default',
      modules: ['ProductFilterAttractionsSearchPage'],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Attraction Info',
      path: ['/attractions/:id'],
      type: 'attractionPage',
      layout: 'default',
      modules: ['AttractionPage'],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'ContentPrivacy',
      path: '/privacy-info',
      type: 'ContentPage',
      layout: 'default',
      modules: ['ProductFilterMainPage', 'PageContentPrivacy'],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'ContentPrivacy',
      path: '/accessibility-info',
      type: 'ContentPage',
      layout: 'default',
      modules: ['ProductFilterMainPage', 'PageContentAccessibility'],
    },
    {
      id: 'Main-Page_66627b4',
      seo: {
        desc: '',
        title: '',
      },
      name: 'Main Page',
      path: '/',
      type: 'indexPage',
      layout: 'default',
      modules: [
        {
          module: 'ProductFilterMainPage',
          sort_index: 1,
        },
        {
          module: 'PromotionBoxes_26ef752',
          sort_index: 2,
        },
        {
          module: 'PackageListView_1563b67',
          sort_index: 7,
        },
        {
          module: 'PackageListView_0b82f3a',
          sort_index: 9,
        },
        {
          module: 'PackageListView_91d0d7c',
          sort_index: 10,
        },
        {
          module: 'Banner_b852778',
          sort_index: 11,
        },
        {
          module: 'Banner_5545f08',
          sort_index: 12,
        },
        {
          module: 'Banner_9924115',
          sort_index: 13,
        },
        {
          module: 'Banner_8693a35',
          sort_index: 14,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Package Info',
      path: [
        '/prom/:promSecret/package/:id',
        '/package/view',
        '/package/:id',
        '/p/:alias',
        '/event/:alias/',
        '/event/:alias/:affiliate',
        '/package/:id/:affiliate',
        '/prom/:promSecret/package/:id/:affiliate',
      ],
      type: 'packagePage',
      layout: 'default',
      modules: ['PackagePage'],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Main Page',
      path: ['/prom/:promSecret', '/prom/:promSecret/:affiliate'],
      type: 'indexPage',
      layout: 'default',
      modules: ['PromoPage'],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Room Info',
      path: '/room/:id',
      type: 'roomPage',
      layout: 'empty',
      modules: [
        'ImgCarousel',
        'SearchDatePicker',
        'RoomInfo',
        'OrderNow',
        'Activities',
        'RoomGeneralDetails',
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Packages Search',
      path: '/packages',
      type: 'searchResultPage',
      layout: 'default',
      modules: ['ProductFilterPackageSearchPage'],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Packages Search',
      path: ['/flights', '/flights/dynamic'],
      type: 'searchResultPage',
      layout: 'default',
      modules: ['ProductFilterFlightSearchPage'],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Packages Search',
      path: '/hotels',
      type: 'searchResultPage',
      layout: 'default',
      modules: ['ProductFilterHotelSearchPage'],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Packages Search',
      path: '/hotels',
      type: 'searchResultPage',
      layout: 'default',
      modules: ['SearchDatePickerHotelPage'],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Checkout',
      path: '/checkout/:id',
      type: 'checkoutPage',
      layout: 'default',
      modules: ['Checkout'],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Manage Order',
      path: '/order/manage',
      type: 'orderPage',
      layout: 'default',
      modules: ['ManageOrder'],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'ContactUs',
      path: '/contact',
      type: 'ContactUsPage',
      layout: 'default',
      modules: ['ProductFilterMainPage', 'ContactUs'],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'AboutUs',
      path: '/about',
      type: 'AboutUsPage',
      layout: 'default',
      modules: ['ProductFilterMainPage', 'PageContentAboutUs'],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Takanon',
      path: '/takanon',
      type: 'ContentPage',
      layout: 'default',
      modules: ['ProductFilterMainPage', 'PageContentTakanon'],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'PassengerInfo',
      path: '/passenger-info',
      type: 'ContentPage',
      layout: 'default',
      modules: ['ProductFilterMainPage', 'PageContentPassenger'],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Package Info',
      path: '/hotel/:id/',
      type: 'hotelPage',
      layout: 'default',
      modules: ['HotelPage'],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Destination Page',
      path: '/destinations',
      type: 'indexPage',
      layout: 'default',
      modules: ['SearchDatePickerMainPage', 'DestinationList'],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'NotFound404',
      path: '/flight/view/:type/:flightId',
      type: 'indexPage',
      layout: 'default',
      modules: ['ProductFilterViewFlightPage', 'ViewFlight'],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'NotFound404',
      path: '/404',
      type: 'indexPage',
      layout: 'default',
      modules: ['NotFound404'],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Attractions Search',
      path: ['/attractions'],
      type: 'searchResultPage',
      layout: 'default',
      modules: [
        {
          module: 'ProductFilterAttractionsSearchPage',
          sort_index: 1,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Attraction Info',
      path: ['/attractions/:id'],
      type: 'attractionPage',
      layout: 'default',
      modules: [
        {
          module: 'AttractionPage',
          sort_index: 1,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'ContentPrivacy',
      path: '/privacy-info',
      type: 'ContentPage',
      layout: 'default',
      modules: [
        {
          module: 'ProductFilterMainPage',
          sort_index: 1,
        },
        {
          module: 'PageContentPrivacy',
          sort_index: 2,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'ContentPrivacy',
      path: '/accessibility-info',
      type: 'ContentPage',
      layout: 'default',
      modules: [
        {
          module: 'ProductFilterMainPage',
          sort_index: 1,
        },
        {
          module: 'PageContentAccessibility',
          sort_index: 2,
        },
      ],
    },
    {
      id: 'Main-Page_66627b4',
      seo: {
        desc: '',
        title: '',
      },
      name: 'Main Page',
      path: '/',
      type: 'indexPage',
      layout: 'default',
      modules: [
        {
          module: 'ProductFilterMainPage',
          sort_index: 1,
        },
        {
          module: 'PromotionBoxes_26ef752',
          sort_index: 2,
        },
        {
          module: 'PackageListView_1563b67',
          sort_index: 7,
        },
        {
          module: 'PackageListView_0b82f3a',
          sort_index: 9,
        },
        {
          module: 'PackageListView_91d0d7c',
          sort_index: 10,
        },
        {
          module: 'Banner_b852778',
          sort_index: 11,
        },
        {
          module: 'Banner_5545f08',
          sort_index: 12,
        },
        {
          module: 'Banner_9924115',
          sort_index: 13,
        },
        {
          module: 'Banner_8693a35',
          sort_index: 14,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Package Info',
      path: [
        '/prom/:promSecret/package/:id',
        '/package/view',
        '/package/:id',
        '/p/:alias',
        '/event/:alias/',
        '/event/:alias/:affiliate',
        '/package/:id/:affiliate',
        '/prom/:promSecret/package/:id/:affiliate',
      ],
      type: 'packagePage',
      layout: 'default',
      modules: [
        {
          module: 'PackagePage',
          sort_index: 1,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Main Page',
      path: ['/prom/:promSecret', '/prom/:promSecret/:affiliate'],
      type: 'indexPage',
      layout: 'default',
      modules: [
        {
          module: 'PromoPage',
          sort_index: 1,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Room Info',
      path: '/room/:id',
      type: 'roomPage',
      layout: 'empty',
      modules: [
        {
          module: 'ImgCarousel',
          sort_index: 1,
        },
        {
          module: 'SearchDatePicker',
          sort_index: 2,
        },
        {
          module: 'RoomInfo',
          sort_index: 3,
        },
        {
          module: 'OrderNow',
          sort_index: 4,
        },
        {
          module: 'Activities',
          sort_index: 5,
        },
        {
          module: 'RoomGeneralDetails',
          sort_index: 6,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Packages Search',
      path: '/packages',
      type: 'searchResultPage',
      layout: 'default',
      modules: [
        {
          module: 'ProductFilterPackageSearchPage',
          sort_index: 1,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Packages Search',
      path: ['/flights', '/flights/dynamic'],
      type: 'searchResultPage',
      layout: 'default',
      modules: [
        {
          module: 'ProductFilterFlightSearchPage',
          sort_index: 1,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Packages Search',
      path: '/hotels',
      type: 'searchResultPage',
      layout: 'default',
      modules: [
        {
          module: 'ProductFilterHotelSearchPage',
          sort_index: 1,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Packages Search',
      path: '/hotels',
      type: 'searchResultPage',
      layout: 'default',
      modules: [
        {
          module: 'SearchDatePickerHotelPage',
          sort_index: 1,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Checkout',
      path: '/checkout/:id',
      type: 'checkoutPage',
      layout: 'default',
      modules: [
        {
          module: 'Checkout',
          sort_index: 1,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Manage Order',
      path: '/order/manage',
      type: 'orderPage',
      layout: 'default',
      modules: [
        {
          module: 'ManageOrder',
          sort_index: 1,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'ContactUs',
      path: '/contact',
      type: 'ContactUsPage',
      layout: 'default',
      modules: [
        {
          module: 'ProductFilterMainPage',
          sort_index: 1,
        },
        {
          module: 'ContactUs',
          sort_index: 2,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'AboutUs',
      path: '/about',
      type: 'AboutUsPage',
      layout: 'default',
      modules: [
        {
          module: 'ProductFilterMainPage',
          sort_index: 1,
        },
        {
          module: 'PageContentAboutUs',
          sort_index: 2,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Takanon',
      path: '/takanon',
      type: 'ContentPage',
      layout: 'default',
      modules: [
        {
          module: 'ProductFilterMainPage',
          sort_index: 1,
        },
        {
          module: 'PageContentTakanon',
          sort_index: 2,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'PassengerInfo',
      path: '/passenger-info',
      type: 'ContentPage',
      layout: 'default',
      modules: [
        {
          module: 'ProductFilterMainPage',
          sort_index: 1,
        },
        {
          module: 'PageContentPassenger',
          sort_index: 2,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Package Info',
      path: '/hotel/:id/',
      type: 'hotelPage',
      layout: 'default',
      modules: [
        {
          module: 'HotelPage',
          sort_index: 1,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'Destination Page',
      path: '/destinations',
      type: 'indexPage',
      layout: 'default',
      modules: [
        {
          module: 'SearchDatePickerMainPage',
          sort_index: 1,
        },
        {
          module: 'DestinationList',
          sort_index: 2,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'NotFound404',
      path: '/flight/view/:type/:flightId',
      type: 'indexPage',
      layout: 'default',
      modules: [
        {
          module: 'ProductFilterViewFlightPage',
          sort_index: 1,
        },
        {
          module: 'ViewFlight',
          sort_index: 2,
        },
      ],
    },
    {
      seo: {
        desc: '',
        title: '',
      },
      name: 'NotFound404',
      path: '/404',
      type: 'indexPage',
      layout: 'default',
      modules: [
        {
          module: 'NotFound404',
          sort_index: 1,
        },
      ],
    },
  ],
  theme: {
    button: 'btn-style-5',
    primary: '#002854',
    tertiary: '#c2c2c2',
    secondary: '#0166ff',
    background: '#fff',
    fontFamily: 'Heebo',
  },
  layouts: {
    empty: {
      topModules: [],
      bottomModules: [],
    },
    default: {
      bottomModules: ['Footer', 'Footer'],
      topModules: ['Header'],
    },
    noFooter: {
      topModules: [],
      bottomModules: ['Footer', 'Footer'],
    },
  },
};
export default appConfig;
